import styled from '@emotion/styled';
import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 5px;
  & * {
    font-size: 1.4rem;
    color: white;
  }
  & .alert-title {
    font-size: 1.7rem;
  }
`;

interface Props {
  errorMessage: string;
  errorTitle: string;
  children?: any;
  action?: any;
}

export const ErrorMessage = ({
  errorMessage,
  errorTitle,
  children,
  action,
}: Props) => {
  return (
    <Root>
      <Alert action={action} variant="filled" severity="info">
        <AlertTitle className="alert-title">{errorTitle}</AlertTitle>
        {errorMessage}
        {children}
      </Alert>
    </Root>
  );
};
